module.exports = __webpack_public_path__ + "img/address.46a7a775.svg";